import Courses from '@/components/courses/Courses'
import CourseList from '@/components/courses/CourseList'
import CreateCourse from '@/components/courses/CreateCourse'
import ManageCourse from '@/components/courses/ManageCourse'
import CourseWrap from '@/components/courses/CourseWrap'

export default [
  {
    path: '/manage-courses',
    component: Courses,
    children: [
      {path: '', component: CourseList},
      {path: 'create', component: CreateCourse},
      {
        path: ':courseKey',
        component: CourseWrap,
        children: [
          {path: '', component: ManageCourse}
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/courses/routes.js